import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import moment from "moment";

import MyButton from "./MyButton";

const styles = {
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  formControl: {
    marginTop: 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: 1,
  },
  paper: {},
  textField: {
    marginLeft: 1,
    marginRight: 1,
    width: 250,
  },
};

class SuKienXuLyDialog extends React.Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.state = {
      open: props.visible,
      fullWidth: true,
      maxWidth: "sm",
      sukien: {
        nguontin: "HCM RADIO",
      }, //thong tin ve su kien
    };
  }
  render() {
    return <div>Hello</div>;
  }
  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
    if (this.props.onClose) {
      this.props.onClose();
    }
  };
  static getDerivedStateFromProps(props, state) {
    return { ...state };
  }
  render() {
    return (
      <React.Fragment>
        <Dialog
          fullWidth={this.props.fullWidth}
          maxWidth={this.props.maxWidth}
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="max-width-dialog-title"
        >
          <DialogTitle id="max-width-dialog-title">Cập nhật sự vụ - Xử lý thông tin đến</DialogTitle>
          <DialogContent>
            <form style={styles.form} noValidate autoComplete="off">
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <TextField id="txtTentau" label="Tên sự vụ:" />
                </Grid>
                <Grid item xs={6}>
                  <TextField id="txtTentau" label="Số hồ sơ:" />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="datetime-local"
                    label="Thời gian(HN):"
                    type="datetime-local"
                    defaultValue="2017-05-24T10:30"
                    format="DD-MM-YYYY"
                    style={styles.textField}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControl style={styles.formControl}>
                    <InputLabel id="demo-simple-select-label">
                      Nơi gửi đến:
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={this.state.sukien.nguontin}
                    >
                      <MenuItem value={"HCM RADIO"}>HCM RADIO</MenuItem>
                      <MenuItem value={"VUNG TAU RADIO"}>
                        VUNG TAU RADIO
                      </MenuItem>
                      <MenuItem value={"KHAC"}>KHAC</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <TextField id="txtTentau" label="Tên đơn vị:" />
                </Grid>
                <Grid item xs={6}>
                  <TextField id="txtTentau" label="Phương thức gửi:" />
                </Grid>         
                <Grid item xs={12}>
                  <TextField id="txtTentau" label="Nội dung thông tin:" />
                </Grid>         
                <Grid item xs={12}>
                  <label>Thông tin cập nhật về phương tiện:</label>
                </Grid>                 
                <Grid item xs={4}>
                  <TextField id="txtTentau" label="Vị trí(VĐ):" />
                </Grid>
                <Grid item xs={4}>
                  <TextField id="txtTentau" label="Vị trí(KĐ):" />
                </Grid>
                <Grid item xs={4}>
                  <FormControl style={styles.formControl}>
                    <InputLabel id="demo-simple-select-label">
                      Khu vực:
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={this.state.sukien.nguontin}
                    >
                      <MenuItem value={"HCM RADIO"}>Vịnh Bắc Bộ</MenuItem>
                      <MenuItem value={"VUNG TAU RADIO"}>
                        Hoàng Sa
                      </MenuItem>
                      <MenuItem value={"KHAC"}>Trường Sa</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextField id="txtTentau" label="Mô tả vị trí:" />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="datetime-local"
                    label="Thời gian vị trí:"
                    type="datetime-local"
                    defaultValue="2017-05-24T10:30"
                    format="DD-MM-YYYY"
                    style={styles.textField}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField id="txtTentau" label="Tên phương tiện:" />
                </Grid>
                <Grid item xs={4}>
                  <TextField id="txtTentau" label="Hô hiệu:" />
                </Grid>
                <Grid item xs={4}>
                  <FormControl style={styles.formControl}>
                    <InputLabel id="demo-simple-select-label">
                      Loại tàu:
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={this.state.sukien.nguontin}
                    >
                      <MenuItem value={"HCM RADIO"}>Tàu dầu</MenuItem>
                      <MenuItem value={"VUNG TAU RADIO"}>Tàu hàng</MenuItem>
                      <MenuItem value={"KHAC"}>Tàu cá</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <FormControl style={styles.formControl}>
                    <InputLabel id="demo-simple-select-label">
                      Quốc tịch:
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={this.state.sukien.nguontin}
                    >
                      <MenuItem value={"HCM RADIO"}>Việt Nam</MenuItem>
                      <MenuItem value={"VUNG TAU RADIO"}>Trung Quốc</MenuItem>
                      <MenuItem value={"KHAC"}>Thái Lan</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <TextField id="txtTentau" label="MMSI:" />
                </Grid>
                <Grid item xs={4}>
                  <TextField id="txtTentau" label="Trọng tải:" />
                </Grid>
                <Grid item xs={4}>
                  <TextField id="txtTentau" label="Tuyến đường từ:" />
                </Grid>
                <Grid item xs={4}>
                  <TextField id="txtTentau" label="Đích đến:" />
                </Grid>
                <Grid item xs={4}>
                  <TextField id="txtTentau" label="Số người:" />
                </Grid>           
                <Grid item xs={4}>
                  <FormControl style={styles.formControl}>
                    <InputLabel id="demo-simple-select-label">
                      Tai nạn:
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={this.state.sukien.nguontin}
                    >
                      <MenuItem value={"HCM RADIO"}>Cháy nổ</MenuItem>
                      <MenuItem value={"VUNG TAU RADIO"}>Đâm va</MenuItem>
                      <MenuItem value={"KHAC"}>Chìm tàu</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>                
                <Grid item xs={8}>
                  <TextField id="txtTentau" label="Mô tả vụ việc:" />
                </Grid>                
                <Grid item xs={12}>
                  <TextField id="txtTentau" label="Chủ tàu/Đại lý:" />
                </Grid>                
                <Grid item xs={6}>
                  <TextField id="txtTentau" label="Địa chỉ:" />
                </Grid>                
                <Grid item xs={6}>
                  <TextField id="txtTentau" label="Điện thoại/Fax:" />
                </Grid>   
                <Grid item xs={12}>
                  <TextField id="txtTentau" label="Tình trạng phương tiện:" />
                </Grid>   
                <Grid item xs={3}>
                  <TextField id="txtTentau" label="Số bị nạn:" />
                </Grid>   
                <Grid item xs={3}>
                  <TextField id="txtTentau" label="Được cứu:" />
                </Grid>                   
                <Grid item xs={3}>
                  <TextField id="txtTentau" label="Bị thương:" />
                </Grid>                   
                <Grid item xs={3}>
                  <TextField id="txtTentau" label="Bị chết:" />
                </Grid>       
                <Grid item xs={3}>
                  <Button variant="contained" component="label">
                    File 1
                    <input type="file" hidden />
                  </Button>
                </Grid>
                <Grid item xs={3}>
                  <Button variant="contained" component="label">
                    File 2
                    <input type="file" hidden />
                  </Button>
                </Grid>
                <Grid item xs={3}>
                  <Button variant="contained" component="label">
                    File 3
                    <input type="file" hidden />
                  </Button>
                </Grid>
                <Grid item xs={3}>
                  <Button variant="contained" component="label">
                    File 4
                    <input type="file" hidden />
                  </Button>
                </Grid>                  
              </Grid>
            </form>
          </DialogContent>
          <DialogActions>
            <MyButton onClick={this.handleClose} color="primary" text="Lưu" />
            <MyButton onClick={this.handleClose} color="primary" text="Thoát" />
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}
export default SuKienXuLyDialog;
